"use client";

import { ReactNode, useEffect, useRef, useState } from "react";
import styles from "@/src/components/Common/FadeIn/FadeIn.module.scss";

type FadeInType = "top";

interface FadeInProps {
  children: ReactNode;
  type?: FadeInType;
  className?: string;
  loading?: boolean;
}

const FadeIn = ({ children, type, className, loading }: FadeInProps) => {
  const wasLoading = useRef(!!loading);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (wasLoading.current && !loading) setAnimate(true);
    wasLoading.current = !!loading;
  }, [loading]);

  const animationClass = animate ? (type === "top" ? styles.top : styles.standard) : "";
  const composed = [className, animationClass].filter(Boolean).join(" ");

  return <div className={composed || undefined}>{children}</div>;
};

export default FadeIn;